import { RefObject, useCallback, useEffect, useState } from 'react'

import { LearnSectionGalleryItemId } from './constants'
import { getConnectionLines } from './utils'

type Line = {
  from: [number, number]
  to: [number, number]
  midpoint: [number, number]
}

export function useConnectionLines(
  refMap: Record<LearnSectionGalleryItemId, HTMLElement | null>,
  containerRef: RefObject<HTMLElement>,
) {
  const [lines, setLines] = useState<Line[]>([])

  const updateLines = useCallback(() => {
    const validMap = Object.fromEntries(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      Object.entries(refMap).filter(([_, element]) => element !== null),
    ) as Record<LearnSectionGalleryItemId, HTMLElement>

    const nextLines = getConnectionLines(validMap, containerRef)
    setLines(nextLines)
  }, [containerRef, refMap])

  useEffect(() => {
    updateLines()

    const resizeObserver = new ResizeObserver(() => {
      updateLines()
    })

    Object.values(refMap).forEach(el => {
      if (el) resizeObserver.observe(el)
    })

    window.addEventListener('resize', updateLines)

    return () => {
      window.removeEventListener('resize', updateLines)
      resizeObserver.disconnect()
    }
  }, [updateLines, refMap])

  return { lines, updateLines }
}
